import Skeleton from '@passkeys/ui/skeleton';
import Text from '@passkeys/ui/text';
import type { ReactNode } from 'react';

import { cn } from '@/ui/utils/classnames';

export interface ItemProps {
  label?: string;
  children: ReactNode;
  className?: string;
  dataTestId?: string;
}

function Item({ label, children, className, dataTestId }: ItemProps) {
  return (
    <div
      className={cn(
        'grid grid-flow-col grid-cols-[repeat(auto-fill,minmax(0,100%))] items-center justify-items-end gap-x-2 py-3',
        className,
      )}
    >
      {label ? (
        <Text
          size={14}
          className="justify-self-start text-gray-500 theme-dark:text-neutral-100"
          dataTestId={dataTestId}
        >
          {label}
        </Text>
      ) : (
        <Skeleton
          width={64}
          height={14}
          className="my-[3px] justify-self-start"
        />
      )}

      {children}
    </div>
  );
}

export default Item;
